import { render, staticRenderFns } from "./DetailRoomCategory.vue?vue&type=template&id=ee8f34b2&scoped=true"
import script from "./DetailRoomCategory.vue?vue&type=script&lang=js"
export * from "./DetailRoomCategory.vue?vue&type=script&lang=js"
import style0 from "./DetailRoomCategory.vue?vue&type=style&index=0&id=ee8f34b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8f34b2",
  null
  
)

export default component.exports